import { CoreIcon } from '../core-icon';
import addCircleSVG from '../../assets/icons/add-circle.svg';
import type { IconProps } from '../core-icon';

export const AddCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={addCircleSVG} {...props} />;
};
